import { defineMeta } from '@/registry/types';

export const dialogMeta = defineMeta({
  name: 'Dialog',
  level: 'organism',
  category: 'feedback',
  classification: 'mui-overrides',
  description:
    'Modal surface for focused tasks and confirmations. Themed MUI Dialog; the action row is ' +
    'padded and right-aligned by the theme, with `align` / `dense` props on DialogActions for ' +
    'adjustments.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Dialog',
  muiDocs: 'https://mui.com/material-ui/react-dialog/',
  a2uiEquivalent: 'Dialog',
  importPath: '@/organisms/Dialog',
  requiredProps: ['open'],
  optionalProps: ['onClose', 'maxWidth', 'fullWidth', 'fullScreen', 'align (DialogActions)', 'dense (DialogActions)'],
  supportedStates: ['open', 'closed'],
  designTokens: ['colors', 'radius', 'shadows', 'spacing', 'typography'],
  accessibility: ['Traps focus; Esc/backdrop close; labelled by DialogTitle.'],
  usageExamples: [
    '<Dialog open={open} onClose={close}><DialogTitle>Isolate host?</DialogTitle><DialogContent><DialogContentText>This cuts network access until you restore it.</DialogContentText></DialogContent></Dialog>',
    '<DialogActions align="stretch" dense><Button>Cancel</Button><Button>OK</Button></DialogActions>',
  ],
  rules: [
    'Body copy goes in `DialogContentText` (themed as `body1`). Do not drop a raw string into `DialogContent`.',
  ],
  antiPatterns: [
    'Do not stack multiple dialogs.',
    'Do not use for non-blocking info (use Snackbar).',
    'Do not pad DialogActions with sx — the theme owns it; use `align`/`dense`.',
  ],
  mountsSurface: 'portal',
  llmSafe: true,
  whenToUse: ['Confirmations, short focused forms'],
  whenNotToUse: ['Large multi-step flows (use a page/Drawer)'],
});

export default dialogMeta;
